import { useAtom } from '@reatom/npm-react'
import { memo } from 'react'

import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'
import { TxCountFormatted } from '@root/shared/core/format'
import { useTranslation } from '@root/shared/localization'

import { TradingPairExploreItemMetricsItem } from './pair-explore-item-metrics-item'

import type { PairModel } from '@root/entities/pair'
import type { PairMetrics } from '@root/entities/pair/model'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
  statsPeriod: PairMetrics.MetricsSpan
} & ClassNameProps

export const TradingPairExploreItemMetricsTxs = memo(
  ({ pair, className, statsPeriod }: Props) => {
    const { t } = useTranslation()

    const [txCount] = useAtom(pair.stats[statsPeriod].transactions)

    return (
      <TradingPairExploreItemMetricsItem className={className}>
        <TradingPairExploreItemMetricsItem.Label>
          {t('common.tx_char')}
        </TradingPairExploreItemMetricsItem.Label>
        <FlashTextContentDistinct>
          <TxCountFormatted txCount={txCount} />
        </FlashTextContentDistinct>
      </TradingPairExploreItemMetricsItem>
    )
  },
)
